import { CurecallBanner } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'

export const LifenConnectNotice = () => {
  const { t } = useTranslation()

  return (
    <CurecallBanner appearance="INFO" className="c-w-full c-text-sm c-py-3">
      {t('pages.auth.wording.lifen-connect-notice')}
    </CurecallBanner>
  )
}
